import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=427f2486&scoped=true&"
import script from "./ai.vue?vue&type=script&lang=js&"
export * from "./ai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f2486",
  null
  
)

export default component.exports